export const SET_BOOKING = 'SET_BOOKING';
export const SET_BOOKINGS = 'SET_BOOKINGS';
export const SET_BOOKING_WITH_FILTER = 'SET_BOOKING_WITH_FILTER';
export const FAILED_UPDATE_BOOKING = 'FAILED_UPDATE_BOOKING';
export const FAILED_GET_BOOKINGS = 'FAILED_GET_BOOKINGS';
export const SET_MAPPEDBOOKINGS = 'SET_MAPPEDBOOKINGS';
export const SET_USER_DATE_FILTER_FIELD = 'SET_USER_DATE_FILTER_FIELD';
export const FAILED_GET_USER_DATE_FILTER_FIELD = 'FAILED_GET_USER_DATE_FILTER_FIELD';
export const BOOK_SUCCESS = 'BOOK_SUCCESS';
export const BOOK_FAILED = 'BOOK_FAILED';
export const REBOOK_SUCCESS = 'REBOOK_SUCCESS';
export const REBOOK_FAILED = 'REBOOK_FAILED';
export const POD_SUCCESS = 'POD_SUCCESS';
export const POD_FAILED = 'POD_FAILED';
export const GET_LABEL_SUCCESS = 'GET_LABEL_SUCCESS';
export const GET_LABEL_FAILED = 'GET_LABEL_FAILED';
export const SET_FETCH_BOOKINGS_FLAG = 'CLEAR_FETCH_BOOKINGS_FLAG';
export const SET_LOCAL_FILTER_ALL = 'SET_LOCAL_FILTER_ALL';
export const SET_LOCAL_FILTER_SELECTEDATE = 'SET_LOCAL_FILTER_SELECTEDATE';
export const SET_LOCAL_FILTER_WAREHOUSEID = 'SET_LOCAL_FILTER_WAREHOUSEID';
export const SET_LOCAL_FILTER_FPID = 'SET_LOCAL_FILTER_FPID';
export const SET_LOCAL_FILTER_SORTFIELD = 'SET_LOCAL_FILTER_SORTFIELD';
export const SET_LOCAL_FILTER_COLUMNFILTER = 'SET_LOCAL_FILTER_COLUMNFILTER';
export const SET_LOCAL_FILTER_ACTIVE_TAB_IND = 'SET_LOCAL_FILTER_ACTIVE_TAB_IND';
export const SET_LOCAL_FILTER_SIMPLESEARCHKEYWORD = 'SET_LOCAL_FILTER_SIMPLESEARCHKEYWORD';
export const SET_LOCAL_FILTER_PROJECTNAME = 'SET_LOCAL_FILTER_PROJECTNAME';
export const SET_LOCAL_FILTER_BOOKINGIDS = 'SET_LOCAL_FILTER_BOOKINGIDS';
export const SET_ATTACHMENTS = 'SET_ATTACHMENTS_DE';
export const FAILED_GET_ATTACHMENTS = 'FAILED_GET_ATTACHMENTS_DE';
export const SET_PODS = 'SET_PODS';
export const FAILED_GET_PODS = 'FAILED_GET_PODS';
export const SUCCESS_UPDATE_BOOKING = 'SUCCESS_UPDATE_BOOKING';
export const RESET_UPDATE_LINE_AND_LINEDETAIL = 'RESET_UPDATE_LINE_AND_LINEDETAIL';
export const SUCCESS_DUPLICATE_BOOKING = 'SUCCESS_DUPLICATE_BOOKING';
export const FAILED_DUPLICATE_BOOKING = 'FAILED_DUPLICATE_BOOKING';
export const SET_LOCAL_FILTER_NEWPOD = 'SET_LOCAL_FILTER_NEWPOD';
export const BOOK_CANCEL_SUCCESS = 'BOOK_CANCEL_SUCCESS';
export const BOOK_CANCEL_FAILED = 'BOOK_CANCEL_FAILED';
export const SET_LOCAL_FILTER_CLIENTPK = 'SET_LOCAL_FILTER_CLIENTPK';
export const SUCCESS_CREATE_BOOKING = 'SUCCESS_CREATE_BOOKING';
export const FAILED_CREATE_BOOKING = 'FAILED_CREATE_BOOKING';
export const GENERATE_XLS_SUCCESS = 'GENERATE_XLS_SUCCESS';
export const GENERATE_XLS_FAILED = 'GENERATE_XLS_FAILED';
export const CHANGE_STATUS_SUCCESS = 'CHANGE_STATUS_SUCCESS';
export const CHANGE_STATUS_FAILED = 'CHANGE_STATUS_FAILED';
export const SET_LOCAL_FILTER_NEWLABEL = 'SET_LOCAL_FILTER_NEWLABEL';
export const SUCCESS_CALC_COLLECTED = 'SUCCESS_CALC_COLLECTED';
export const FAILED_CALC_COLLECTED = 'FAILED_CALC_COLLECTED';
export const SET_LOCAL_FILTER_DOWNLOADOPTION = 'SET_LOCAL_FILTER_DOWNLOADOPTION';
export const RESET_BOOKING = 'RESET_BOOKING';
export const RESET_ATTACHMENTS = 'RESET_ATTACHMENTS';
export const RESET_PODS = 'RESET_PODS';
export const SET_FETCH_GEO_FLAG = 'SET_FETCH_GEO_FLAG';
export const CLEAR_ERR_MSG = 'CLEAR_ERR_MSG';
export const SET_LOCAL_FILTER_PAGEITEMCNT = 'SET_LOCAL_FILTER_PAGEITEMCNT';
export const SET_LOCAL_FILTER_PAGEINDEX = 'SET_LOCAL_FILTER_PAGEINDEX';
export const SET_LOCAL_FILTER_DMESTATUS = 'SET_LOCAL_FILTER_DMESTATUS';
export const SUCCESS_TICK_MANUAL_BOOK = 'SUCCESS_TICK_MANUAL_BOOK';
export const FAILED_TICK_MANUAL_BOOK = 'FAILED_TICK_MANUAL_BOOK';
export const RESET_TICK_MANUAL_BOOK = 'RESET_TICK_MANUAL_BOOK';
export const SUCCESS_MANUAL_BOOK = 'SUCCESS_MANUAL_BOOK';
export const FAILED_MANUAL_BOOK = 'FAILED_MANUAL_BOOK';
export const BOOK_EDIT_SUCCESS = 'BOOK_EDIT_SUCCESS';
export const BOOK_EDIT_FAILED = 'BOOK_EDIT_FAILED';
export const SUCCESS_CREATE_ORDER = 'SUCCESS_CREATE_ORDER';
export const FAILED_CREATE_ORDER = 'FAILED_CREATE_ORDER';
export const SUCCESS_GET_ORDER_SUMMARY = 'SUCCESS_GET_ORDER_SUMMARY';
export const FAILED_GET_ORDER_SUMMARY = 'FAILED_GET_ORDER_SUMMARY';
export const RESET_MANIFEST_REPORT = 'RESET_MANIFEST_REPORT';
export const SUCCESS_GET_MANIFEST_REPORT = 'SUCCESS_GET_MANIFEST_REPORT';
export const FAIELD_GET_MANIFEST_REPORT = 'FAIELD_GET_MANIFEST_REPORT';
export const GET_TRACK_FAILED = 'GET_TRACK_FAILED';
export const DO_NOTHING = 'DO_NOTHING';
export const SUCCESS_FP_PRICING = 'SUCCESS_FP_PRICING';
export const FAILED_FP_PRICING = 'FAILED_FP_PRICING';
export const RESET_PRICING_INFOS = 'RESET_PRICING_INFOS';
export const SUCCESS_GET_PRICING_INFOS = 'SUCCESS_GET_PRICING_INFOS';
export const SET_ERROR_MSG = 'SET_ERROR_MSG';
export const RESET_REFRESH_BOOKINGS_FLAG = 'RESET_REFRESH_BOOKINGS_FLAG';
export const SUCCESS_SEND_EMAIL = 'SUCCESS_SEND_EMAIL';
export const FAILED_SEND_EMAIL = 'FAILED_SEND_EMAIL';
export const RESET_AUTO_SELECTED = 'RESET_AUTO_SELECTED';
export const SUCCESS_AUTO_AUGMENT = 'SUCCESS_AUTO_AUGMENT';
export const FAILED_AUTO_AUGMENT = 'FAILED_AUTO_AUGMENT';
export const SUCCESS_REVERT_AUGMENT = 'SUCCESS_REVERT_AUGMENT';
export const FAILED_REVERT_AUGMENT = 'FAILED_REVERT_AUGMENT';
export const SUCCESS_PRICING_ANALYSIS = 'SUCCESS_PRICING_ANALYSIS';
export const FAILED_PRICING_ANALYSIS = 'FAILED_PRICING_ANALYSIS';
export const SUCCESS_AUGMENT_PU_DATE = 'SUCCESS_AUGMENT_PU_DATE';
export const FAILED_AUGMENT_PU_DATE = 'FAILED_AUGMENT_PU_DATE';
export const RESET_NO_BOOKING = 'RESET_NO_BOOKING';
export const SUCCESS_GET_CLIENT_PROCESS = 'SUCCESS_GET_CLIENT_PROCESS';
export const FAILED_GET_CLIENT_PROCESS = 'FAILED_GET_CLIENT_PROCESS';
export const GET_LABELS_INFO = 'GET_LABELS_INFO';
export const SUCCESS_GET_LABELS_INFO = 'SUCCESS_GET_LABELS_INFO';
export const FAILED_GET_LABELS_INFO = 'FAILED_GET_LABELS_INFO';
export const GET_LABELS_INFO_FOR_BOOKINGS = 'GET_LABELS_INFO_FOR_BOOKINGS';
export const SUCCESS_GET_LABELS_INFO_FOR_BOOKINGS = 'SUCCESS_GET_LABELS_INFO_FOR_BOOKINGS';
export const FAILED_GET_LABELS_INFO_FOR_BOOKINGS = 'FAILED_GET_LABELS_INFO_FOR_BOOKINGS';
export const SUCCESS_UPDATE_AUGMENT = 'SUCCESS_UPDATE_AUGMENT';
export const FAILED_UPDATE_AUGMENT = 'FAILED_UPDATE_AUGMENT';
export const RESET_SUMMARY_OF_BOOKINGS = 'RESET_SUMMARY_OF_BOOKINGS';
export const SUCCESS_GET_SUMMARY_OF_BOOKINGS = 'SUCCESS_GET_SUMMARY_OF_BOOKINGS';
export const FAILED_GET_SUMMARY_OF_BOOKINGS = 'FAILED_GET_SUMMARY_OF_BOOKINGS';
export const SUCCESS_GET_DME_LABEL = 'SUCCESS_GET_DME_LABEL';
export const FAILED_GET_DME_LABEL = 'FAILED_GET_DME_LABEL';
export const SUCCESS_REPACK = 'SUCCESS_REPACK';
export const FAILED_REPACK = 'FAILED_REPACK';
export const SUCCESS_DME_CANCEL_BOOK = 'SUCCESS_DME_CANCEL_BOOK';
export const FAILED_DME_CANCEL_BOOK = 'FAILED_DME_CANCEL_BOOK';
export const SUCCESS_DME_CANCEL_BOOK_REQUEST = 'SUCCESS_DME_CANCEL_BOOK_REQUEST';
export const FAILED_DME_CANCEL_BOOK_REQUEST = 'FAILED_DME_CANCEL_BOOK_REQUEST';
export const SUCCESS_GET_STATUS_PAGE_URL = 'SUCCESS_GET_STATUS_PAGE_URL';
export const FAILED_GET_STATUS_PAGE_URL = 'FAILED_GET_STATUS_PAGE_URL';
export const RESET_STATUS_PAGE_URL = 'RESET_STATUS_PAGE_URL';
export const SUCCESS_GET_BOOKING_FOR_BIDDING = 'SUCCESS_GET_BOOKING_FOR_BIDDING';
export const FAILED_GET_BOOKING_FOR_BIDDING = 'FAILED_GET_BOOKING_FOR_BIDDING';
export const SUCCESS_APPROVE_BOOKING = 'SUCCESS_APPROVE_BOOKING';
export const FAILED_APPROVE_BOOKING = 'FAILED_APPROVE_BOOKING';
export const SET_QUICK_QUOTE_BOOKING_DATA = 'SET_QUICK_QUOTE_BOOKING';
export const RESET_QUICK_QUOTE_BOOKING_DATA = 'RESET_QUICK_QUOTE_BOOKING_DATA';
export const SUCCSS_BOOK_AND_MANIFEST = 'SUCCSS_BOOK_AND_MANIFEST';
export const GET_BOOKING_FOLLOWING_STATUS_SUCCESS = 'GET_BOOKING_FOLLOWING_STATUS_SUCCESS';
export const GET_BOOKING_FOLLOWING_STATUS_FAILED = 'GET_BOOKING_FOLLOWING_STATUS_FAILED';
export const FOLLOW_BOOKING_REQUEST = 'FOLLOW_BOOKING_REQUEST';
export const FOLLOW_BOOKING_SUCCESS = 'FOLLOW_BOOKING_SUCCESS';
export const FOLLOW_BOOKING_FAILED = 'FOLLOW_BOOKING_FAILED';
export const UNFOLLOW_BOOKING_REQUEST = 'UNFOLLOW_BOOKING_REQUEST';
export const UNFOLLOW_BOOKING_SUCCESS = 'UNFOLLOW_BOOKING_SUCCESS';
export const UNFOLLOW_BOOKING_FAILED = 'UNFOLLOW_BOOKING_FAILED';



// WEBPACK FOOTER //
// src/state/constants/bookingConstants.js